import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MessageModule } from 'primeng/message';
import { PrimecustomModule } from 'src/app/shared/primeng.custom.module';
import { loginPageText } from '../../services/enums';
import { environment } from 'src/environments/environment';
import { GoogleRecaptchaComponent } from '../../../shared/component/google-recaptcha/google-recaptcha.component';
import { SsoService } from '../../services/sso.service';
import { RESET_PASSWORD } from 'src/app/shared/routeLink.constant';
import { FORGOT_PASSWORD_API_URL } from 'src/app/shared/api.constant';
import { ToastMessageOptions } from 'primeng/api';
@Component({
  selector: 'app-verify-email',
  standalone: true,
  imports: [
    FormsModule,
    MessageModule,
    CommonModule,
    ReactiveFormsModule,
    PrimecustomModule,
    GoogleRecaptchaComponent,
    RouterModule,
  ],
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
})
export class VerifyEmailComponent implements OnInit {
  messages!: ToastMessageOptions[];
  email = '';
  verifyLinkForm!: FormGroup;
  loading = false;
  svgPath: any = 'assets/img/common/';
  TextEnum = loginPageText;
  captcha_result: string | number = '';
  siteKey = environment.recaptcha.siteKey;
  constructor(
    private readonly sso: SsoService,
    private readonly formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.verifyLinkForm = this.formBuilder.group({
      useremail: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ]),
      ],
      captcha: [null, Validators.required],
    });

    this.verifyLinkForm.markAsUntouched();
  }
  verifyEmail() {
    if (this.verifyLinkForm.invalid) {
      this.verifyLinkForm.markAllAsTouched();
      return;
    }

    this.loading = true;

    const body = {
      requestType: 'PASSWORD_RESET',
      email: this.verifyLinkForm.get('useremail')?.value,
      clientType: 'CLIENT_TYPE_WEB',
      continueUrl: `${window.location.origin}/${RESET_PASSWORD}`,
    };

    this.sso.post(FORGOT_PASSWORD_API_URL, body).subscribe({
      next: (data) => {
        if (data.status) {
          this.messages = [
            {
              severity: 'success',
              summary: data?.data?.message,
            },
          ];
          this.verifyLinkForm.reset();
        } else {
          this.messages = [
            {
              severity: 'warn',
              summary: data?.data?.message,
            },
          ];
        }

        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        this.messages = [
          {
            severity: 'warn',
            summary: 'Something went wrong. Please try again',
          },
        ];
        return error.message;
      },
    });
  }
}
